'use strict';

var utils = require('./utils');

/**
 * disables the zoom and then reenables so iphone doesn't zoom in
 */
function zoomHandle() {
    utils.disableZoom();
    setTimeout(function () {
        utils.enableZoom();
    }, 500);
}

/**
 * initializes zoom handle form select via touch event
 */
function init() {
    $('body').on('touchstart', 'select, input, textarea', function () {
        zoomHandle();
    });
}

module.exports = init;
